import {RouterModule, Routes} from '@angular/router';
import {MainComponent} from "../../layouts/main/main.component";
import {IndexComponent} from "./index/index.component";
import {AuthGuard} from "../../guards/auth.guard";


const routes: Routes = [
  {
    path: 'payment-history',
    component: MainComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: IndexComponent
      },
    ]
  }
];

export const paymentHistoryRouting = RouterModule.forChild(routes);
